import { render, staticRenderFns } from "./LanguageComponent.vue?vue&type=template&id=93d3514a&scoped=true"
import script from "./LanguageComponent.vue?vue&type=script&lang=js"
export * from "./LanguageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d3514a",
  null
  
)

export default component.exports